import { BlockType } from '../../types/index.js';
import { CollectionListBlock as Component } from './Block.js';
export const RegisteredCollectionListBlock = (_intl) => ({
    recommendedName: 'CollectionList',
    Component,
    config: {
        type: BlockType.Block,
        deprecated: true,
    },
});
//# sourceMappingURL=registered.js.map